import { Component, Input } from '@angular/core';
import { GrantFileUploadStatus } from '@core/models';

@Component({
  selector: 'app-upload-data-status',
  templateUrl: './upload-data-status.component.html',
  styleUrls: ['./upload-data-status.component.scss'],
  standalone: false,
})
export class UploadStatusComponent {
  public dataStatuses: GrantFileUploadStatus[];

  @Input()
  set orderStatuses(statuses: GrantFileUploadStatus[]) {
    this.dataStatuses = [...statuses].sort((obj1, obj2) =>
      obj1.type.localeCompare(obj2.type),
    );
  }
}
